const nonBlank = (value) => value && value.trim().length > 0 ? value.trim() : null;
/**
 * The external page a visitor books a public event on, or `null` when the
 * call to action should be hidden. Registration is a link out to the venue's
 * own booking flow (Tock, Resy, ...), never an in-app RSVP (#330).
 *
 * The event's own `registrationUrl` wins. The venue's `bookingUrl` is only a
 * fallback for events that require a reservation, so walk-in events don't
 * grow a "Book" button pointing at the tasting room.
 *
 * @example
 * const url = resolveEventBookingUrl(event, event.venue);
 * if (url) window.open(url, '_blank', 'noopener');
 */
export const resolveEventBookingUrl = (event, venue) => {
    if (event.status !== 'published' || event.audience !== 'public')
        return null;
    const own = nonBlank(event.registrationUrl);
    if (own)
        return own;
    return event.requiresReservation ? nonBlank(venue?.bookingUrl) : null;
};
